import React from 'react'

const SliderIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.44789 3.99992H2.66667C2.29848 3.99992 2 3.70144 2 3.33325C2 2.96506 2.29848 2.66659 2.66667 2.66659H5.44789C5.72348 1.89111 6.46537 1.33325 7.33333 1.33325C8.2013 1.33325 8.94319 1.89111 9.21878 2.66659H13.3333C13.7015 2.66659 14 2.96506 14 3.33325C14 3.70144 13.7015 3.99992 13.3333 3.99992H9.21878C8.94319 4.7754 8.2013 5.33325 7.33333 5.33325C6.46537 5.33325 5.72348 4.7754 5.44789 3.99992ZM6.66667 3.33325C6.66667 2.96811 6.96819 2.66659 7.33333 2.66659C7.69848 2.66659 8 2.96811 8 3.33325C8 3.6984 7.69848 3.99992 7.33333 3.99992C6.96819 3.99992 6.66667 3.6984 6.66667 3.33325Z"
      fill="#282828"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.66667 13.3333C2.29848 13.3333 2 13.0348 2 12.6666C2 12.2984 2.29848 11.9999 2.66667 11.9999H3.44789C3.72348 11.2244 4.46537 10.6666 5.33333 10.6666C6.2013 10.6666 6.94319 11.2244 7.21878 11.9999H13.3333C13.7015 11.9999 14 12.2984 14 12.6666C14 13.0348 13.7015 13.3333 13.3333 13.3333H7.21878C6.94319 14.1087 6.2013 14.6666 5.33333 14.6666C4.46537 14.6666 3.72348 14.1087 3.44789 13.3333H2.66667ZM4.66667 12.6666C4.66667 12.3014 4.96819 11.9999 5.33333 11.9999C5.69848 11.9999 6 12.3014 6 12.6666C6 13.0317 5.69848 13.3333 5.33333 13.3333C4.96819 13.3333 4.66667 13.0317 4.66667 12.6666Z"
      fill="#282828"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.66667 8.66659C2.29848 8.66659 2 8.36811 2 7.99992C2 7.63173 2.29848 7.33325 2.66667 7.33325H9.44789C9.72348 6.55777 10.4654 5.99992 11.3333 5.99992C12.2013 5.99992 12.9432 6.55777 13.2188 7.33325H13.3333C13.7015 7.33325 14 7.63173 14 7.99992C14 8.36811 13.7015 8.66659 13.3333 8.66659H13.2188C12.9432 9.44206 12.2013 9.99992 11.3333 9.99992C10.4654 9.99992 9.72348 9.44206 9.44789 8.66659H2.66667ZM11.3333 7.33325C10.9682 7.33325 10.6667 7.63478 10.6667 7.99992C10.6667 8.36506 10.9682 8.66659 11.3333 8.66659C11.6985 8.66659 12 8.36506 12 7.99992C12 7.63478 11.6985 7.33325 11.3333 7.33325Z"
      fill="#282828"
    />
  </svg>
)

export default SliderIcon
